import { Directive, ElementRef, HostListener } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { InputNumber } from 'primeng/inputnumber';
import { LocaleHelper } from '../helpers/localeHelper';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'p-inputNumber[isLanguageAgnostic]',
    standalone: false,
})
export class IsLanguageAgnosticDirective {
    private locale: string;
    private separators: Set<string>;

    constructor(
        private el: ElementRef,
        private component: InputNumber,
        private translateService: CustomTranslateService,
    ) {
        this.locale = LocaleHelper.mapCountryAccronymToLocale(this.translateService.currentLang);
        this.translateService.onLangChange.subscribe((params) => {
            this.locale = LocaleHelper.mapCountryAccronymToLocale(params.lang ?? '');
        });
        this.separators = this.translateService.langs
            .map((l) => LocaleHelper.mapCountryAccronymToLocale(l))
            .map((locale) => this.getLocaleDecimalSeparator(locale))
            .reduce<Set<string>>((prev, cur) => {
                prev.add(cur);
                return prev;
            }, new Set());
    }

    @HostListener('keydown', ['$event']) onKeyboardDown(ev: KeyboardEvent) {
        if (this.separators.has(ev.key)) {
            const curSeparator = this.getLocaleDecimalSeparator(this.locale);
            ev.preventDefault();
            const target = ev.target;
            if (target === null) {
                throw Error();
            }
            const ipt = target as HTMLInputElement;
            if (ipt.value.includes(curSeparator)) {
                return;
            }
            ipt.value = ipt.value + curSeparator;
        }
    }

    private getLocaleDecimalSeparator(locale: string): string {
        const numberWithDecimalSeparator = 1.1;
        return (
            Intl.NumberFormat(locale)
                .formatToParts(numberWithDecimalSeparator)
                .find((part) => part.type === 'decimal')?.value ?? '.'
        );
    }
}
